import { initialize } from 'utils/initialize';
import { getMenus } from 'functions/fnRequestAPIs/fnMenus';
import InvoicePage from 'components/invoice/InvoicePage';
import PageLayout from 'layouts/Page.layout';

const Invoices = ({ staticContent }) => {
    const metaTags = {
        title: 'Facturación',
        shouldIndex: false,
    };

    return (
        <PageLayout
            staticContent={{
                ...staticContent,
                metaTags,
            }}
        >
            <InvoicePage />
        </PageLayout>
    );
};

export async function getServerSideProps(context) {
    const { reduxStore, apolloClient } = await initialize({
        withReduxStore: true,
        withApolloClient: true,
        withUserContext: true,
        context,
    });

    const staticContent = await getMenus(context, apolloClient);

    return {
        props: {
            initialReduxState: reduxStore.getState(),
            staticContent,
        },
    };
}

export default Invoices;
